import { combineReducers } from "redux";
import profileReducer from "./profileReducer";
import dataReducer from "./dataReducer";

const rootReducer = combineReducers({
  profileReducer,
  dataReducer,
});

export default rootReducer;
